import { render, staticRenderFns } from "./platformPC.vue?vue&type=template&id=20d302a6&"
import script from "./platformPC.vue?vue&type=script&lang=js&"
export * from "./platformPC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports